import { ConvexReactClient, type MutationOptions } from "convex/react";
import type { ArgsAndOptions, FunctionArgs, FunctionReference, FunctionReference_future, FunctionReturnType, OptionalRestArgs } from "convex/server";
import { observeAccessFailure } from "./organization-access-errors";

/** Covers useMutation/useAction and imperative client calls through the same client. */
export class AccessAwareConvexClient extends ConvexReactClient {
  override mutation<Mutation extends FunctionReference<"mutation"> | FunctionReference_future<"mutation">>(
    mutation: Mutation,
    ...args: ArgsAndOptions<Mutation, MutationOptions<FunctionArgs<Mutation>>>
  ): Promise<FunctionReturnType<Mutation>> {
    return observeAccessFailure(super.mutation(mutation, ...args));
  }

  override action<Action extends FunctionReference<"action"> | FunctionReference_future<"action">>(
    action: Action,
    ...args: OptionalRestArgs<Action>
  ): Promise<FunctionReturnType<Action>> {
    return observeAccessFailure(super.action(action, ...args));
  }
}
